import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../shared/interfaces/api';
import { MayBe } from '../../shared/services/network-status';

const BASE_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class Transaction {
  private http = inject(HttpClient);

  public token = signal<string>('');

  public expiryTime = signal<MayBe<number>>(null);

  public getPaymentMethods(transactionId: string): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${BASE_URL}/methods`, {
      headers: this.getHeaders(),
      params: { transactionId },
    });
  }

  public getTransactionById(transactionId: string): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${BASE_URL}/transaction/${transactionId}`).pipe(
      tap((res) => {
        const expiry = new Date(res.data.createdAt).getTime() + 15 * 60 * 1000; //? 15 minutes
        this.expiryTime.set(expiry);
      })
    );
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders().set('Sbpay-api-key', this.getToken());
  }

  public getMethodById(methodId: string, transactionId: string): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${BASE_URL}/methods/${methodId}`, {
      headers: this.getHeaders(),
      params: { transactionId },
    });
  }

  public updatePaymentTransaction(
    transactionId: string,
    payload: any
  ): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(
      `${BASE_URL}/transaction/update-payment/${transactionId}`,
      payload,
      {
        headers: this.getHeaders(),
      }
    );
  }

  public getAccountNumber(
    method_id: string,
    payment_type: string,
    transactionId: string
  ): Observable<ApiResponse<any>> {
    const params = {
      method_id,
      payment_type,
      transactionId,
    };
    return this.http.get<ApiResponse<any>>(`${BASE_URL}/methods/fetch-account-no`, {
      params,
      headers: this.getHeaders(),
    });
  }

  public verifyTransaction(transactionId: string, payload: any): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(
      `${BASE_URL}/payment-verify/${transactionId}`,
      payload,
      {
        headers: this.getHeaders(),
      }
    );
  }

  public setToken(value: string) {
    this.token.set(value);
  }

  public getToken() {
    return this.token();
  }
}
